/**
 * This is exported as a separate function so that we can mock it.
 * @alias isInDev
 * @internal
 */
export default (function () {
  return process.env.NODE_ENV === 'development';
});